import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { expanded: Boolean, key: String }
  static targets = ["content", "icon"]

  declare expandedValue: boolean
  declare keyValue: string
  declare contentTarget: HTMLElement
  declare iconTarget: HTMLElement
  declare hasIconTarget: boolean

  connect() {
    // Restore state from localStorage if key exists
    const stored = localStorage.getItem(this.storageKey)
    if (stored !== null) {
      this.expandedValue = stored === "true"
    }
    this.applyState(false) // Apply without animation on initial load
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    localStorage.setItem(this.storageKey, String(this.expandedValue))
    this.applyState(true)
  }

  private get storageKey(): string {
    return `sidebar_${this.keyValue}`
  }

  private applyState(animate: boolean) {
    const content = this.contentTarget

    if (!animate) {
      // Disable transitions for initial load
      content.style.transition = "none"
    }

    if (this.expandedValue) {
      // Expanded state
      content.style.maxHeight = `${content.scrollHeight}px`
      content.style.opacity = "1"
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("rotate-180")
      }
    } else {
      // Collapsed state
      content.style.maxHeight = "0"
      content.style.opacity = "0"
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("rotate-180")
      }
    }

    if (!animate) {
      // Force reflow and re-enable transitions
      content.offsetHeight
      content.style.transition = ""
    }
  }
}
